const mutations = {
  setImportBuildingOwners(state, payload) {
    state.importBuildingOwners = payload;
  },
};

export default mutations;
